import { render, staticRenderFns } from "./SobreOCurso.vue?vue&type=template&id=46b9fea7&"
import script from "./SobreOCurso.vue?vue&type=script&lang=js&"
export * from "./SobreOCurso.vue?vue&type=script&lang=js&"
import style0 from "./SobreOCurso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CursosShowCalendario: require('/opt/buildhome/repo/components/Cursos/Show/Calendario.vue').default,CursosShowParceirosTopo: require('/opt/buildhome/repo/components/Cursos/Show/ParceirosTopo.vue').default})


/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VDialog,VDivider,VIcon,VLayout})
